// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Col, Row, Table } from 'react-bootstrap'
import { Link } from 'react-router'
import { MainSidebar } from '../components/mainsidebar'
import { SecSidebar } from '../components/secsidebar'

export class ModuleListing extends Component {
    constructor(props) {
        super(props)

        this.module = []
        this.data = this.props.appData
        this.handleViewActivity = this.handleViewActivity.bind(this)

        this.hidden = { display: 'none' }
        this.visible = { display: 'block' }

        this.path = {
            rating: '/assets/images/Ratings/',
            modules: '/assets/images/Modules/',
            webgl: 'http://webgl.enablerinteractive.com/'
        }
    }

    evalRatingIcon(strikes, size) {
        switch (Math.round(strikes)) {
            case 0: return this.path.rating + size + '/Icon_Badge_excellent.png'
            case 1: return this.path.rating + size + '/Icon_Badge_good.png'
            case 2: return this.path.rating + size + '/Icon_Badge_pass.png'
            case 3: return this.path.rating + size + '/Icon_Badge_failed.png'
            default: return ''
        }
    }

    evalRatingModule(strikes) {

        switch (Math.round(strikes)) {
            case 0: return 'Excellent'
            case 1: return 'Good'
            case 2: return 'Pass'
            case 3: return 'Failed'
            default: return 'N/A'
        }
    }

    get moduleInfo() {
        let markUp = (
            <div></div>
        )

        if (typeof this.module !== 'undefined') {
            let vitalStats = (
                <div className="vital-stats">
                </div>
            )
            let moduleImage = this.path.modules + this.module.name + "/Icon_Module_" + this.module.name + ".png"
            let rating = this.evalRatingIcon(this.module.strikes, 'Large')
            let ratingStyle = this.module.strikes === null ? this.hidden : this.visible

            markUp = (
                <section className="module-info left-panel">
                    <h3 className="module-title title">
                        {this.module.name}
                    </h3>
                    <div className="module-image image">
                        <img src={moduleImage} alt={this.module.name} />
                        <div className="rating" style={ratingStyle}>
                            <img src={rating} alt="rating" />
                        </div>
                    </div>
                    {vitalStats}
                </section>
            )
        }

        return markUp
    }

    handleViewActivity(e) {
        e.preventDefault()

        let id = e.target.getAttribute('data')

        document.getElementById('summary' + id).style.display = 'none'
        document.getElementById('activity' + id).style.display = 'block'

    }

    handleClose(e) {
        e.preventDefault()

        let id = e.target.getAttribute('data')

        document.getElementById('activity' + id).style.display = 'none'
        document.getElementById('summary' + id).style.display = 'block'
    }

    get scenarios() {
        if (typeof this.module !== 'undefined') {
            if (typeof this.module.scenarios !== 'undefined') {
                return this.module.scenarios.map((scenario, index) => {
                    let scenarioImage = this.path.modules + scenario.module + "/Icon_Scenario_" + scenario.name + ".png"
                    let rating = this.evalRatingIcon(scenario.strikes, 'Small')
                    let webgl = this.path.webgl + scenario.module + "/" + scenario.name
                    let emptyGameStyle = scenario.data.length === 0 ? this.hidden : this.visible
                    let actionButtons = ''

                    if (this.data.profileType === 'provider') {
                        actionButtons = (
                            <Row>
                                <Col sm={12}>
                                    <label>
                                        <a href="#" data={index} onClick={this.handleViewActivity}>View Activity</a>
                                    </label>
                                </Col>
                            </Row>
                        )
                    }
                    else {
                        actionButtons = (
                            <Row>
                                <Col sm={6}>
                                    <label>
                                        <a href="#" data={index} onClick={this.handleViewActivity}>View Activity</a>
                                    </label>
                                </Col>
                                <Col sm={6}>
                                    <label><Link to={webgl} target="_blank">Launch</Link></label>
                                </Col>
                            </Row>
                        )
                    }

                    return (
                        <Row bsClass="scenario row" key={index} id={"scenario" + index}>

                            <div className="info">
                                <Col sm={4}>
                                    <div className="image">
                                        <img src={scenarioImage} alt={scenario.name} />
                                        <h4 className="scenario-name name">{scenario.name}</h4>
                                    </div>
                                </Col>
                                <Col sm={8} className="summary" id={"summary" + index}>
                                    <Row>
                                        <Col sm={12}>
                                            <div className="rating" style={emptyGameStyle}>
                                                <img src={rating} alt="rating" />
                                            </div>
                                            <label>
                                                <span className="field-title">Technical Points</span>
                                                <span className="field-value">{scenario.tp + " / " + scenario.ttp}</span>
                                            </label>

                                            <label>
                                                <span className="field-title">Service Points</span>
                                                <span className="field-value">{scenario.sp + " / " + scenario.tsp}</span>
                                            </label>
                                            <label>
                                                <span className="field-title">Communication Points</span>
                                                <span className="field-value">{scenario.cp + " / " + scenario.tcp}</span>
                                            </label>

                                        </Col>
                                    </Row>
                                    {actionButtons}
                                </Col>
                                <Col sm={8} className="activity" style={{ display: 'none' }} id={"activity" + index}>
                                    <Row>
                                        <Col smOffset={8} sm={4}>
                                            <label>
                                                <a href="#" data={index} onClick={this.handleClose}>Close</a>
                                            </label>
                                        </Col>
                                    </Row>
                                    <Table responsive bsClass="activity-data table" striped >
                                        <thead>
                                            <tr>
                                                <th>S.No.</th>
                                                <th>Date</th>
                                                <th>Rating</th>
                                                <th>T.P.</th>
                                                <th>S.P.</th>
                                                <th>C.P.</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.getActivity(scenario.data)}
                                        </tbody>
                                    </Table>
                                </Col>
                            </div>

                        </Row>
                    )
                })
            }
        }
    }

    getActivity(data) {
        return data.map((item, index) => {
            let createdDate = new Date(item.created_at)

            return (

                <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{createdDate.getDate() + "/" + (createdDate.getMonth() + 1) + "/" + createdDate.getFullYear()}</td>
                    <td>{this.evalRatingModule(item.tracking_data.number_of_strikes)}</td>
                    <td>{item.tracking_data.technical_points + "/" + item.tracking_data.total_technical_points}</td>
                    <td>{item.tracking_data.service_points + "/" + item.tracking_data.total_service_points}</td>
                    <td>{item.tracking_data.communication_points + "/" + item.tracking_data.total_communication_points}</td>
                </tr>
            )
        })
    }

    componentWillMount() {
        if (!window.sessionStorage.getItem('authToken')) {
            console.log("not logged in")
            this.props.router.push('/login')
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            if (storedData.profileType === 'worker') {
                let data = {
                    profileType: storedData.profileType,
                    loginStatus: storedData.loginStatus,
                    authToken: storedData.authToken,
                    average_strikes: storedData.average_strikes,
                    confirmed: storedData.confirmed,
                    email: storedData.email,
                    gender: storedData.gender,
                    purpose: storedData.purpose,
                    uid: storedData.uid,
                    fname: storedData.fname,
                    lname: storedData.lname,
                    last_active_at: storedData.last_active_at,
                    workers: JSON.parse(storedData.workers),
                    globalModules: JSON.parse(storedData.globalModules)
                }

                this.props.handleWorkerDataUpdateFromSessionStorage(data)
            }
            else {
                let data = {
                    profileType: storedData.profileType,
                    loginStatus: storedData.loginStatus,
                    authToken: storedData.authToken,
                    id: storedData.uid,
                    admin_first_name: storedData.fname,
                    admin_last_name: storedData.lname,
                    name: storedData.company,
                    address: storedData.address,
                    license_count: storedData.licenseCount,
                    globalModules: JSON.parse(storedData.globalModules)
                }

                this.props.handleProviderDataUpdateFromSessionStorage(data)
            }
        }
    }

    render() {
        this.data = this.props.appData

        if (this.data.workers.length > 0) {
            this.module = this.data.workers[this.props.location.query.worker].modules[this.props.location.query.id]
        }

        let breadcrumb

        if (this.data.profileType === 'provider') {
            breadcrumb = (<div className="breadcrumb"><span><Link to="/dashboard">Dashboard</Link></span>/<span><Link to={"/dashboard/profile?userId=" + this.props.location.query.worker}>Profile</Link></span>/</div>)
        }
        else {
            breadcrumb = (
                <div className="breadcrumb">
                    <span><Link to={"/profile?userId=" + this.props.location.query.worker}>Profile</Link></span>/
                </div>
            )
        }

        return (
            <div className="module-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={2}
                />

                <SecSidebar
                    profileType={this.props.appData.profileType}
                    profile={1}
                    menuItemsKey={"default"}
                />

                <div className="main-body">
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <div className="main-header">
                                {breadcrumb}
                                <h2 className="title">Module Listing</h2>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col sm={2} md={2} xs={2} smOffset={1} mdOffset={1} xsOffset={1}>
                            {this.moduleInfo}
                        </Col>

                        <Col sm={8} md={8} >
                            <section className="scenario-list right-panel">
                                <Row>
                                    <Col sm={12} >
                                        {this.scenarios}
                                    </Col>
                                </Row>
                            </section>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/moduleListing.js